import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../Auth";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import firebase from "firebase";
import AvatarModal from "../AvatarModal";
import "./style.scss";

const ProfileEdit = () => {
  const authContext = useContext(AuthContext);
  const [checked, setChecked] = useState(false);
  const [isOpenAvatarChange, setOpenAvatarChange] = useState(false);
  const [isValid, setValid] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [nickName, setNickName] = useState("");
  const history = useHistory();
  const db = firebase.firestore();
  useEffect(() => {
    if (!authContext.currentUser) {
      history.push("/");
    } else {
      if (localStorage.notify === "true") setChecked(true);
      else setChecked(false);
    }
  }, []);
  const getProfilePhoto = () => {
    const photoURL = localStorage.photo;
    if (photoURL) return photoURL;
    else return require("./../../assets/images/0.svg");
  };
  const handleClickAvatarChange = () => {
    setOpenAvatarChange(true);
  };
  const handleClickImage = (index) => {
    const storage = firebase.storage();
    const storageRef = storage.ref(`avatars/${index}.svg`);
    storageRef.getDownloadURL().then((url) => {
      localStorage.photo = url;
      handleCloseAvatarChange();
    });
  };
  const handleChange = (checked) => {
    setChecked(checked);
  };
  const handleClickSave = () => {
    const id = localStorage.nickName.substr(localStorage.nickName.length - 4);
    if (nickName === "") {
      db.collection("users").doc(localStorage.email).update({
        photo: localStorage.photo,
        notify: checked,
        notified: false,
      });
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        history.push("/profile");
      }, 2000);
    } else {
      db.collection("users")
        .where("nickName", "==", nickName + id)
        .get()
        .then((querySnapshot) => {
          let valid = true;
          querySnapshot.forEach((doc) => {
            if (doc.data()) {
              setValid(false);
              valid = false;
            }
          });
          if (valid) {
            db.collection("users")
              .doc(localStorage.email)
              .update({
                nickName: nickName + id,
                photo: localStorage.photo,
                notify: checked,
                notified: false,
              });
            localStorage.nickName = nickName + id;
            setLoading(true);
            setTimeout(() => {
              setLoading(false);
              history.push("/profile");
            }, 2000);
          }
        });
    }
  };

  const handleCloseAvatarChange = () => {
    setOpenAvatarChange(false);
  };

  const handleInputChange = (e) => {
    if (e.target.value[e.target.value.length - 1] !== " ") {
      setNickName(e.target.value);
    }
  };

  return (
    <>
      {isOpenAvatarChange ? (
        <AvatarModal
          isOpen={isOpenAvatarChange}
          handleCloseModal={handleCloseAvatarChange}
          handleClickImage={handleClickImage}
        />
      ) : (
        <>
          {isLoading ? (
            <div className="loader-container">
              <img
                alt="loader"
                src={require(`../../assets/images/SVG/1.svg`)}
                className="loader"
              ></img>
              <div>SAVING PROFILE...</div>
            </div>
          ) : (
            ""
          )}
          <div
            className="edit"
            style={isLoading ? { opacity: 0 } : { opacity: 1 }}
          >
            <div className="edit-header">
              <div className="edit-header-photo">
                <img alt="avatar" src={getProfilePhoto()}></img>
              </div>
              <div>{localStorage.nickName}</div>
            </div>
            <div className="edit-body">
              <div className="edit-body-comment">Enter new nickname:</div>
              <input
                type="text"
                className="edit-body-input"
                onChange={handleInputChange}
                value={nickName}
                pattern="[A-Za-z]{10}"
                maxLength={10}
              ></input>
              {!isValid ? (
                <div className="edit-body-alert">
                  Sorry this nickname is taken
                </div>
              ) : (
                ""
              )}
              <div className="edit-body-avatar">
                <img alt="avatar" src={getProfilePhoto()}></img>
              </div>
              <div
                className="edit-body-change"
                onClick={handleClickAvatarChange}
              >
                Change avatar image
              </div>
              <div className="edit-body-switch">
                <span style={{ marginRight: "10px" }}>Notifications</span>
                <Switch
                  onChange={handleChange}
                  checked={checked}
                  width={65}
                  height={29}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor={"transparent"}
                  onColor={"transparent"}
                  handleDiameter={17}
                  className="edit-body-switch-toggle"
                />
                <span style={{ marginLeft: "10px", width: "20px" }}>
                  {checked ? "on" : "off"}
                </span>
              </div>
              <button className="edit-body-button" onClick={handleClickSave}>
                Save
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default ProfileEdit;
